<template>
  <div>
    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between">
      <!-- 搜索 -->
      <div>
        <el-input
          style="width: 300px; margin-right: 10px"
          prefix-icon="el-icon-search"
          v-model="projectName"
          :disabled="showAdvanceSearchVisible"
          size="small"
          @keydown.enter.native="onSearch"
          @clear="onSearch"
          placeholder="请输入项目名称进行搜索..."
          clearable
        >
        </el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="onSearch"
          size="small"
          :disabled="showAdvanceSearchVisible"
          >搜索</el-button
        >
        <!-- <el-button type="primary"   size="small" @click="showAdvanceSearchVisible =!showAdvanceSearchVisible"> 
				     <i :class="showAdvanceSearchVisible?'fa fa-angle-double-up':'fa fa-angle-double-down'"	aria-hidden="true"></i>
					高级搜索</el-button> -->
      </div>
      <!-- 右边工具 -->
      <div>
        <!-- <el-upload style="display: inline-flex;margin-right: 8px" :headers="headers" :show-file-list="false"
					:before-upload="beforeUpload" :on-success="onSuccess" :on-error="onError"
					:disbaled="importDataDisabled" action="/work/project/income_import">
					<el-button type="success" :icon="importDataBtnIcon" :disabled="importDataDisabled" size="small">
						{{importDataBtnText}}
					</el-button>
				</el-upload>
				<el-button type="success" @click="exportData" icon="el-icon-download" size="small"> 导出数据 </el-button> -->

        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="showAddView"
          size="small"
          v-if="qx"
          >添加合同金额</el-button
        >
      </div>
    </div>

    <!-- 动画效果 -->
    <transition name="slide-fade">
      <!-- 高级搜索框  -->
      <div
        v-show="showAdvanceSearchVisible"
        style="
          border: 1px solid #409eff;
          border-radius: 5px;
          box-sizing: border-box;
          padding: 5px;
          margin: 10px 0px;
        "
      >
        <el-row>
          <el-col :span="12">
            项目名称:
            <el-select
              v-model="searchValue.projectId"
              size="mini"
              style="width: 130px"
              placeholder="项目名称"
              clearable
            >
              <el-option
                v-for="item in myProjects"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12">
            期次:
            <el-select
              v-model="searchValue.period"
              size="mini"
              style="width: 130px"
              placeholder="期次"
              clearable
            >
              <el-option
                v-for="item in periods"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-col>
          <!-- 	<el-col :span="7">
						聘用形式:
						<el-radio-group v-model="searchValue.engageForm">
							<el-radio label="劳动合同">劳动合同</el-radio>
							<el-radio label="劳务合同">劳务合同</el-radio>
						</el-radio-group>
					</el-col> -->
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :span="12">
            金额日期:
            <el-date-picker
              v-model="searchValue.rqScope"
              size="mini"
              type="daterange"
              value-format="yyyy-MM-dd"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
            >
            </el-date-picker>
          </el-col>
          <el-col :span="5" :offset="7">
            <el-button size="mini" @click="quxiao">取消</el-button>
            <el-button
              @click="onSearch"
              size="mini"
              icon="el-icon-search"
              type="primary"
              >搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
    </transition>

    <!-- 表格 -->
    <div style="margin-top: 20px">
      <el-table
        :data="incomeData"
        stripe
        border
        :row-style="{ height: '58px' }"
        height="calc(100vh - 278px)"
        :cell-style="{ padding: '5px 0' }"
        fit
        size="small"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="width: 100%"
      >
        <!-- 多选框 -->
        <!-- <el-table-column type="selection" align="center" width="55"></el-table-column> -->
        <el-table-column
          prop="bm"
          label="项目编码"
          fixed
          align="center"
          width="130"
        >
        </el-table-column>
        <!-- <el-table-column prop="projectId" label="项目ID" fixed sortable align="center" width="90">
				</el-table-column> -->
        <el-table-column
          prop="projectName"
          label="项目名称"
          fixed
          align="center"
          min-width="160"
        >
        </el-table-column>
        <el-table-column
          prop="rq"
          label="预收款日期"
          sortable
          align="center"
          width="130"
        >
        </el-table-column>
        <el-table-column
          prop="periodName"
          label="批次"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column label="合同金额" sortable align="center" width="130" :sort-method="(a, b) => a.income - b.income">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.income) }}元</span>
            <!-- <span v-if="scope.row.income<10000">{{scope.row.income}}</span> <span style="font-size: 10px"
							v-if="scope.row.income<10000">元</span>
						<el-tag v-if="scope.row.income>=10000">{{scope.row.income/10000}}</el-tag> <span
							style="font-size: 10px" v-if="scope.row.income>=10000">万元</span> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建日期"
          sortable
          align="center"
          width="120"
          :formatter="dateTimeTwoLine"
          class-name="cell-two-line"
        >
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="修改日期"
          sortable
          align="center"
          width="120"
          :formatter="dateTimeTwoLine"
          class-name="cell-two-line"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="175"
          v-if="qx"
        >
          <template slot-scope="scope">
            <!-- <el-button type="primary" size="mini" style="padding: 2px">编辑</el-button> -->
            <el-button
              type="primary"
              size="mini"
              @click="showEditView(scope.row)"
              :disabled="kaiguan(scope.row.createTime)"
              >编辑</el-button
            >
            <!-- <el-button type="danger" size="mini" style="padding: 2px">删除</el-button> -->
            <el-button
              type="danger"
              @click="deleteRecord(scope.row)"
              size="mini"
              :disabled="kaiguan(scope.row.createTime)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div style="display: flex; justify-content: flex-end; margin-top: 5px">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          :page-sizes="[10, 20, 50, 100, 200, 1000]"
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="total"
          :current-page="page"
          :page-size="limit"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 弹出框  dialogVisible:是否弹出 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="70%"       :close-on-click-modal="false"
      :close-on-press-escape="false"
>
      <div>
        <!-- 增加一层 el-form表单，可以数据校验 -->
        <el-form ref="inputForm" :model="inputObj" :rules="rules">
          <el-row>
            <el-col :span="12">
              <el-form-item label="项目名称" prop="projectId">
                <el-select
                  v-model="inputObj.projectId"
                  placeholder="请选择"
                  size="mini"
                  :disabled="xmShow"
                  filterable
                  style="width: 250px"
                >
                  <el-option
                    v-for="item in myProjects"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="预收款日期" prop="rq">
                <el-date-picker
                  size="mini"
                  v-model="inputObj.rq"
                  style="width: 250px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="合同批次" prop="period">
                <el-select
                  v-model="inputObj.period"
                  placeholder="请选择"
                  size="mini"
                  style="width: 250px"
                >
                  <el-option
                    v-for="item in periods"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="    合同金额" prop="income">
                <span> &nbsp;&nbsp;</span>
                <el-input
                  type="number"
                  size="mini"
                  prefix-icon="el-icon-edit"
                  style="width: 250px"
                  v-model="inputObj.income"
                  placeholder="单位(元)"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button @click="doChance">取 消</el-button>
        <el-button type="primary" @click="doAddRecord">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { kz } from "../../utils/MyFunction";

export default {
  name: "ProjIncome",
  data() {
    return {
      qx: true, // 总经理、销售总监编辑的权限
      headers: {
        userIdStr: window.sessionStorage.getItem("userIdStr"),
      },
      // kz: false,
      importDataDisabled: false,
      importDataBtnText: "导入数据",
      importDataBtnIcon: "el-icon-upload2",
      title: "",
      xmShow: false,
      incomeData: [], // 存放查询结果
      showAdvanceSearchVisible: false,
      searchValue: {
        projectId: null,
        rqScope: "",
        period: "",
      },
      loading: false,
      total: 0,
      page: 1,
      limit: 50,
      projectName: "",
      dialogVisible: false,
      // 新增收入对象
      inputObj: {
        id: null,
        projectId: null,
        rq: "",
        period: "",
        income: null,
      },
      myProjects: [], //项目id-项目名称下拉框
      periods: [], //期次下拉框
      rules: {
        projectId: [
          {
            required: true,
            message: "请选择项目名称",
            trigger: "blur",
          },
        ],
        rq: [
          {
            required: true,
            message: "请选择金额日期",
            trigger: "blur",
          },
        ],
        period: [
          {
            required: true,
            message: "请选择期次",
            trigger: "blur",
          },
        ],
        income: [
          {
            required: true,
            message: "请输入合同金额",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.quanxian();
    this.initIncome();
    this.initDim();
  },
  methods: {
    moneyNumber(val) {
      return val.toLocaleString("zh-Hans-CN", {
        style: "currency",
        currency: "CNY",
      });
      // return val.toLocaleString()
    },
    quanxian() {
      if (!window.sessionStorage.getItem("userRoleId")) {
        //权限为空
        // 暂时不做处理，本来应该直接退出
      } else {
        if (window.sessionStorage.getItem("userRoleId") == 8) {
          this.qx = false;
        }
        if (window.sessionStorage.getItem("userRoleId") == 17) {
          this.qx = false;
        }
        // 销售(角色id 2)只读：隐藏"添加"按钮与整个操作列
        if (this.doesItContain([2]).length > 0) {
          this.qx = false;
        }
      }
    },
    kaiguan(sj) {
      var sf = kz(sj);
      return sf;
    },
    quxiao() {
      this.showAdvanceSearchVisible = false;
      this.searchValue.projectId = null;
      this.searchValue.rqScope = "";
      this.searchValue.period = "";
    },
    onSuccess() {
      this.importDataBtnIcon = "el-icon-upload2";
      this.importDataBtnText = "导入数据";
      this.importDataDisabled = false;
      this.initIncome();
      this.$message("导入数据成功！");
    },
    onError() {
      this.importDataBtnIcon = "el-icon-upload2";
      this.importDataBtnText = "导入数据";
      this.importDataDisabled = false;
      this.$message("导入数据失败！");
    },
    beforeUpload() {
      this.importDataBtnIcon = "el-icon-loading";
      this.importDataBtnText = "正在导入";
      this.importDataDisabled = true; //禁用
    },
    exportData() {
      // this.downloadRequest('/project/income_export')
      this.downloadRequest(
        "/project/income_export?projectName=" + this.projectName
      );
    },
    doChance() {
      this.dialogVisible = false;
      this.initIncome();
    },
    showEditView(data) {
      this.title = "编辑合同金额";
      this.dialogVisible = true;
      this.xmShow = true;
      this.inputObj = data;
    },
    deleteRecord(data) {
      this.$confirm(
        "此操作将永久删除 " +
          data.projectName +
          "的该条合同金额明细, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.postRequest2("/project/income_delete?id=" + data.id).then(
            (resp) => {
              if (resp) {
                this.initIncome();
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    doAddRecord() {
      if (this.inputObj.id) {
        // 编辑修改
        // alert(JSON.stringify(this.inputObj))
        this.$refs["inputForm"].validate((valid) => {
          if (valid) {
            //验证通过
            this.postRequest2("/project/income_update", this.inputObj).then(
              (resp) => {
                if (resp) {
                  this.dialogVisible = false;
                  this.initIncome();
                }
              }
            );
          }
        });
      } else {
        // 添加
        this.$refs["inputForm"].validate((valid) => {
          if (valid) {
            //验证通过
            this.postRequest2("/project/income_add", this.inputObj).then(
              (resp) => {
                if (resp) {
                  this.dialogVisible = false;
                  this.initIncome();
                }
              }
            );
          }
        });
      }
      // this.initIncome()
      // this.dialogVisible = false
    },
    initDim() {
      if (!window.sessionStorage.getItem("myProjects")) {
        this.getRequest("/dim/my_project").then((resp) => {
          if (resp) {
            this.myProjects = resp.result;
            this.saveDictCache("myProjects", resp.result);
          }
        });
      } else {
        this.myProjects = this.dictCache("myProjects");
      }
      if (!window.sessionStorage.getItem("periods")) {
        this.postRequest("/dim/dim_table_char/period_code").then((resp) => {
          if (resp) {
            this.periods = resp.result;
            this.saveDictCache("periods", resp.result);
          }
        });
      } else {
        this.periods = this.dictCache("periods");
      }
    },
    currentChange(currentPage) {
      this.page = currentPage;
      this.initIncome();
    },
    sizeChange(limit) {
      this.limit = limit;
      this.page = 1;
      this.initIncome();
    },
    showAddView() {
      this.title = "添加合同金额";
      this.xmShow = false;
      this.dialogVisible = true;
      this.inputObj = {
        id: null,
        projectId: null,
        rq: "",
        income: null,
        // createTime: null,
        // updateTime: null
      };
      this.getRequest("/dim/my_project").then((resp) => {
        if (resp) {
          this.myProjects = resp.result;
        }
      });
      this.postRequest("/dim/dim_table_char/period_code").then((resp) => {
        if (resp) {
          this.periods = resp.result;
        }
      });
    },
    // 搜索入口：先回到第 1 页再查（原来搜索不重置页码，第 N 页搜索会空白）
    onSearch() {
      this.page = 1;
      this.initIncome();
    },

    initIncome() {
      this.loading = true;
      let url =
        "/project/income_list/?page=" + this.page + "&limit=" + this.limit;
      // 项目名称与高级条件一起带上：原来分两条分支（普通只拼项目名称、高级只拼高级条件），
      // 翻页时走的是无参调用 -> 高级条件被丢掉。
      url += "&projectName=" + this.projectName;
      if (this.searchValue.projectId) {
        url += "&projectId=" + this.searchValue.projectId;
      }
      if (this.searchValue.period) {
        url += "&period=" + this.searchValue.period;
      }
      if (this.searchValue.rqScope) {
        url += "&rqScope=" + this.searchValue.rqScope;
      }

      this.getRequest(url).then((resp) => {
        this.loading = false;
        if (resp) {
          console.log(resp.data);
          this.incomeData = resp.data;
          this.total = resp.count;
        }
      });
    },
  },
};
</script>

<style>
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.8s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
	        /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
